import React, { useState, useEffect } from 'react';
import Axios from '../../Components/Axios/Axios';
import Auth from '../../Components/Auth/Auth';
import { useHistory } from 'react-router-dom';
import { USER_KEY } from '../../Constants/index';
import { Button, Grid, Paper, TextField } from '@mui/material';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import FadeLoader from "react-spinners/FadeLoader";
import dateFormat from 'dateformat';
import SearchIcon from '@mui/icons-material/Search';

function CheckInHistory({ refresh }) {
    // For History
    const history = useHistory();

    // Set Loading
    const [loading, setLoading] = useState(false);

    // For Set Style Paper
    const paperStyle = { padding: 20, width: 'auto' }

    // For get Data Check-in History
    const [dataCheckHistory, setDataCheckHistory] = useState([]);

    // For get data from user login
    const tokenData = JSON.parse(localStorage.getItem(USER_KEY));
    const token = tokenData.token;
    const _empID = tokenData.emp_info[0].emp_id;
    const _empCode = tokenData.emp_info[0].emp_code;
    const _empName = tokenData.emp_info[0].fNameLao + " " + tokenData.emp_info[0].lNameLao;
    const _empGender = tokenData.emp_info[0].emp_gender;

    let _empGen;
    if (_empGender == 'F') {
        _empGen = "ທ່ານນາງ"
    } else {
        _empGen = "ທ່ານ"
    }
    const _empFull = _empGen + " " + _empName;

    // For Start Date Search
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    // for Loading Data
    const loadData = async () => {
        setLoading(true)

        setTimeout(() => {
            setLoading(false)
        }, 500);
    }

    useEffect(() => {
        loadData()
    }, [refresh])

    // Function for Search Button
    const searchCheckHistory = async () => {
        if (startDate.length != 0 && endDate.length != 0) {
            if (startDate <= endDate) {
                try {
                    // Set Start and End Date Data
                    let dateData = {
                        "start_date": startDate,
                        "end_date": endDate,
                        "employee_id": _empID
                    }

                    await Axios.post("Report/Staff/Check_in/History", dateData, { headers: { Authorization: `Bearer ${token}` } }).then(res => {
                        // Check token Expired
                        if (res.data.result_code == '403') {
                            Auth.logout(() => {
                                history.push("/");
                            });
                        }

                        if (res.data.result_code == "200") {
                            setDataCheckHistory(res.data.check_in_info);
                        } else {
                            setDataCheckHistory([])
                        }
                    })
                } catch (error) {
                    // console.log(error)
                }
            }
        }
    }

    return (
        <>
            {loading ? <>
                <div className='manage_loading'>
                    <FadeLoader color={'#ED1C24'} loading={loading} size={10} />
                </div>
            </> : <>
                <div className='manage_title'>ປະຫວັດການ Check-in</div>

                <Paper elevation={10} style={paperStyle} className='manage_paper'>
                    <Grid container>
                        <Grid item xs={2}>
                            <Grid item xs={10} style={{ marginBottom: 10 }}>
                                <span className='manage_input_label'>ລະຫັດພະນັກງານ:</span>
                            </Grid>

                            <Grid item xs={10}>
                                <TextField
                                    autoComplete='off'
                                    className='form-control mt-1'
                                    id="input-with-icon-textfield"
                                    size='small'
                                    variant='outlined'
                                    fullWidth
                                    value={_empCode}
                                    disabled
                                />
                            </Grid>
                        </Grid>

                        <Grid item xs={4}>
                            <Grid item xs={11} style={{ marginBottom: 10 }}>
                                <span className='manage_input_label'>ຊື່ ແລະ ນາມສະກຸນ:</span>
                            </Grid>

                            <Grid item xs={11}>
                                <TextField
                                    autoComplete='off'
                                    className='form-control mt-1'
                                    id="input-with-icon-textfield"
                                    size='small'
                                    variant='outlined'
                                    fullWidth
                                    value={_empFull}
                                    disabled
                                />
                            </Grid>
                        </Grid>


                        <Grid item xs={2}>
                            <Grid item xs={10} style={{ marginBottom: 10 }}>
                                <span className='manage_input_label'>ເລີ່ມວັນທີ:</span>
                            </Grid>

                            <Grid item xs={10}>
                                <TextField
                                    autoComplete='off'
                                    className='form-control mt-1'
                                    id="input-with-icon-textfield"
                                    size='small'
                                    variant='outlined'
                                    fullWidth
                                    type='date'
                                    onChange={(e) => { setStartDate(e.target.value) }}
                                />
                            </Grid>
                        </Grid>

                        <Grid item xs={2}>
                            <Grid item xs={10} style={{ marginBottom: 10 }}>
                                <span className='manage_input_label'>ຫາວັນທີ:</span>
                            </Grid>

                            <Grid item xs={10}>
                                <TextField
                                    autoComplete='off'
                                    className='form-control mt-1'
                                    id="input-with-icon-textfield"
                                    size='small'
                                    variant='outlined'
                                    fullWidth
                                    type='date'
                                    onChange={(e) => { setEndDate(e.target.value) }}
                                />
                            </Grid>
                        </Grid>

                        <Grid item xs={2}>
                            <Grid item xs={12} style={{ marginTop: 33 }}>
                                <Button className="manage_search_button" fullWidth variant="outlined" onClick={searchCheckHistory}><SearchIcon />ເບິ່ງຂໍ້ມູນ</Button>
                            </Grid>
                        </Grid>

                    </Grid>
                </Paper>

                {dataCheckHistory && dataCheckHistory.length > 0 ? <>
                    <Paper elevation={10} style={paperStyle} className='manage_paper'>
                        <div className='manage_title'>ລາຍລະອຽດການ Check-in</div>
                        <Grid item xs={12} style={{ marginTop: 20 }}>
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className='manage_table_header' align='center'><span className='manage_table_headtext'>ລໍາດັບ</span></TableCell>
                                            <TableCell className='manage_table_header' align='left'><span className='manage_table_headtext'>ແຂວງ</span></TableCell>
                                            <TableCell className='manage_table_header' align='left'><span className='manage_table_headtext'>ສູນບໍລິການ</span></TableCell>
                                            <TableCell className='manage_table_header' align='left'><span className='manage_table_headtext'>ປ່ອງບໍລິການ</span></TableCell>
                                            <TableCell className='manage_table_header' align='left'><span className='manage_table_headtext'>ລະຫັດ User</span></TableCell>
                                            <TableCell className='manage_table_header' align='center'><span className='manage_table_headtext'>ວັນທີ</span></TableCell>
                                            <TableCell className='manage_table_header' align='center'><span className='manage_table_headtext'>Check-in</span></TableCell>
                                            <TableCell className='manage_table_header' align='center'><span className='manage_table_headtext'>Check-out</span></TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {dataCheckHistory && dataCheckHistory.length > 0 ?
                                            <>
                                                {dataCheckHistory.map((row, idx) => (
                                                    <TableRow key={idx}>
                                                        <TableCell align='center'><span className='manage_table_data'>{idx + 1}</span></TableCell>
                                                        <TableCell align='left'><span className='manage_table_data'>{row.prov_name}</span></TableCell>
                                                        <TableCell align='left'><span className='manage_table_data'>{row.site_name}</span></TableCell>
                                                        <TableCell align='left'><span className='manage_table_data'>{row.counter_name}</span></TableCell>
                                                        <TableCell align='left'><span className='manage_table_data'>{row.user_id}</span></TableCell>
                                                        <TableCell align='center'>
                                                            <span className='manage_table_data'>
                                                                {dateFormat(row.check_in, "dd/mm/yyyy")}
                                                            </span>
                                                        </TableCell>
                                                        <TableCell align='center'>
                                                            <span className='manage_table_data'>
                                                                {dateFormat(row.check_in, "HH:MM:ss")}
                                                            </span>
                                                        </TableCell>
                                                        <TableCell align='center'>
                                                            <span className='manage_table_data'>
                                                                {row.check_out == null ? <>...</> : <>
                                                                    {dateFormat(row.check_out, "HH:MM:ss")}
                                                                </>}
                                                            </span>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </> : <>
                                                <TableBody>
                                                    <TableCell style={{ justifyContent: "center", alignItems: 'center' }}>No Data...</TableCell>
                                                </TableBody>
                                            </>}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Paper>
                </> : <></>}
            </>}
        </>
    )
}

export default CheckInHistory